import { createFileRoute, Link } from '@tanstack/react-router';
import { Share2 } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { SettingsPanel } from '@/components/settings/SettingsPanel';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/settings')({ component: SettingsPage });

function SettingsPage() {
  return (
    <>
      <PageHeader
        title="설정"
        description="챗봇 · 레이트리밋 · RAG · 에이전트 · 기억"
        actions={
          // 페디버스 액터 프로필(ap_name/ap_summary)도 같은 settings 테이블에 있지만
          // 저장 후 Update(Person) 발송이 따로 필요해 전용 화면에 둠.
          <Button asChild variant="outline" size="sm">
            <Link to="/fediverse"><Share2 /> 페디버스 프로필</Link>
          </Button>
        }
      />
      <div className="mt-6"><SettingsPanel /></div>
    </>
  );
}
